import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import moment from "moment";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

import ShopsContext from "../../../../context/ShopsContext";
import formatSegmentLabel from "../../../../utilities/formatSegmentLabel";

function AddSegmentBlockModal({ show, handleClose, product, segments, onAdded }) {
    const shopsContext = useContext(ShopsContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [date, setDate] = useState("");
    const [segmentId, setSegmentId] = useState("");

    const reset = useCallback(() => {
        setLoading(false);
        setError(null);
        setDate(moment().format("YYYY-MM-DD"));
        setSegmentId("");
    }, []);

    const handleSave = useCallback(async () => {
        if(!date) {
            setError("Datum is vereist.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const params = {
                shopId: shopsContext.currentShop.id,
                productId: product.id,
                date,
            };
            if(segmentId) {
                params.segmentId = parseInt(segmentId, 10);
            }
            const response = await axios.post("/addRentalProductSegmentBlock", params);
            if(response.data.valid) {
                handleClose();
                onAdded?.();
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
        setLoading(false);
    }, [shopsContext.currentShop.id, product, date, segmentId, handleClose, onAdded]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ reset }>
            <Modal.Header closeButton>
                <Modal.Title>Blokkering toevoegen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <div className="form-group">
                    <label htmlFor="blockDate">Datum</label>
                    <input
                        type="date"
                        className="form-control"
                        id="blockDate"
                        value={ date }
                        onChange={ (event) => setDate(event.target.value) }
                        disabled={ loading }
                    />
                </div>
                <div className="form-group mb-0">
                    <label htmlFor="blockSegment">Segment</label>
                    <select
                        className="form-control"
                        id="blockSegment"
                        value={ segmentId }
                        onChange={ (event) => setSegmentId(event.target.value) }
                        disabled={ loading }
                    >
                        <option value="">Hele dag</option>
                        { segments && segments.map((segment) => (
                            <option key={ segment.id } value={ segment.id }>
                                { formatSegmentLabel(segment.startTime, segment.durationInMinutes) }
                            </option>
                        ))}
                    </select>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleren
                </Button>
                <Button variant="primary" onClick={ handleSave } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Toevoegen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
AddSegmentBlockModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    segments: PropTypes.array,
    onAdded: PropTypes.func,
}

export default React.memo(AddSegmentBlockModal);
